import { RoleType, User } from "./types";

export function hasAnyRoles(user: User | null | undefined, roles: RoleType[]): boolean {
  return (
    (user?.roles &&
      user.roles.some((role) => {
        if (role?.name) {
          return roles.indexOf(role?.name) >= 0;
        }
        return false;
      })) ||
    false
  );
}